"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ipfLogoAsBase64 = exports.ipfTheme = exports.contrastIpf = exports.paletteColorsIpf = void 0;
var core_1 = require("@material-ui/core");
var theme_1 = require("./theme");
var createMixins_1 = __importDefault(require("@material-ui/core/styles/createMixins"));
exports.paletteColorsIpf = {
    primary: '#393939',
    secondary: '#ed1c24',
    error: '#B00020',
    background: '#ffffff',
    text: '#1c1c1c',
};
exports.contrastIpf = {
    primary: '#e4f6ed',
    secondary: '#ffffff',
    greyText: '#888888',
};
var typographyIpf = {
    fontFamily: 'Lato',
    h1: { fontFamily: 'Lato', fontWeight: 300, fontSize: '96px', lineHeight: '127px', letterSpacing: '-1.5px' },
    h2: { fontFamily: 'Lato', fontWeight: 300, fontSize: '60px', lineHeight: '79px', letterSpacing: '-0.5px' },
    h3: { fontFamily: 'Lato', fontSize: '48px', lineHeight: '63px' },
    h4: { fontFamily: 'Lato', fontSize: '34px', lineHeight: '45px', letterSpacing: '0.25px' },
    h5: { fontFamily: 'Lato', fontSize: '24px', lineHeight: '32px' },
    h6: { fontFamily: 'Lato', fontWeight: 500, fontSize: '20px', lineHeight: '26px', letterSpacing: '0.15px' },
    subtitle1: { fontFamily: 'Lato', fontSize: '16px', lineHeight: '19px', letterSpacing: '0.15px' },
    subtitle2: {
        fontFamily: 'Lato',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '16.41px',
        letterSpacing: '0.1px',
    },
    body1: { fontFamily: 'Lato', fontSize: '18px', lineHeight: '200%', letterSpacing: '0.5px' },
    body2: { fontFamily: 'Lato', fontSize: '14px', lineHeight: '16px', letterSpacing: '0.25px' },
    button: { fontFamily: 'Lato', fontWeight: 500, fontSize: '14px', letterSpacing: '1.25px' },
    caption: { fontFamily: 'Lato', fontSize: '12px', lineHeight: '14px', letterSpacing: '0.4px' },
    overline: { fontFamily: 'Lato', fontSize: '10px', lineHeight: '12px', letterSpacing: '1.5px' },
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.ipfTheme = function (themeStyle) {
    var typographyLanguage = theme_1.languageFont(themeStyle.language);
    var typography = typographyLanguage || typographyIpf;
    var mixins = createMixins_1.default(theme_1.breakpoints, theme_1.spacing, {
        themeStyle: __assign(__assign({}, themeStyle), { appBarColor: exports.paletteColorsIpf.primary }),
    });
    return core_1.createMuiTheme({
        mixins: mixins,
        palette: {
            type: 'light',
            primary: {
                main: exports.paletteColorsIpf.primary,
            },
            secondary: {
                main: exports.paletteColorsIpf.secondary,
            },
            error: {
                main: exports.paletteColorsIpf.error,
            },
            background: {
                default: exports.paletteColorsIpf.background,
            },
            text: {
                primary: exports.paletteColorsIpf.text,
            },
        },
        typography: typography,
        overrides: {
            MuiCssBaseline: {
                '@global': {
                    html: {
                        height: '100%',
                    },
                    body: {
                        height: '100%',
                    },
                },
            },
        },
    });
};
exports.ipfLogoAsBase64 = 'data:image/png;base64,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';
//# sourceMappingURL=ipfTheme.js.map